<div
    class="flex row justify-space-between root"
    [class.add]="tag.state === 1"
    [class.remove]="tag.state === 2"
>
    <div class="button" (click)="add()">
        <mat-icon>add</mat-icon>
    </div>
    <span>{{ tag.tag.name }}</span>
    <div class="button" (click)="remove()">
        <mat-icon>remove</mat-icon>
    </div>
</div>
